import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'

import ChartistTooltip from 'chartist-plugin-tooltips-updated'

Vue.use(Vuex)
const options = {
  chartPadding: {
    right: 50,
    left: 20,
    top: 5,
    bottom: 5,
  },
  fullWidth: true,
  showPoint: true,
  lineSmooth: true,
  axisY: {
    showGrid: true,
    showLabel: true,
    offset: 0,
  },
  axisX: {
    showGrid: true,
    showLabel: true,
    offset: 20,
  },
  showArea: false,
  plugins: [ChartistTooltip({ anchorToPoint: false, appendToBody: true, seriesName: false })],
}

const state = {
  isLoadingDashboard: false,
  dashboard: [],
  dataCart: {},
  optionsCart: options,
  totalWeeklySales: 0,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
